// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1iYLM","rootCenter":"LoadMoreObserver_rootCenter__2yZbT","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__24TeO"};